import axios from 'axios';
import { getB2bToken, logoutB2b } from '../b2b/utils/authB2b';

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '/api',
});

http.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = getB2bToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    // Si token expiré/invalide -> logout + redirection
    if (typeof window !== 'undefined' && status === 401) {
      if (message === 'Token expiré' || message === 'Token invalide') {
        logoutB2b();
        window.location.href = '/b2b-login'; // adapte ton route
      }
    }
    return Promise.reject(error);
  }
);
